import {Command, TextSelection, EditorState, Transaction} from "prosemirror-state";


export const enterKeyInBlockquote:Command = (state:EditorState, dispatch?) => {
	// Print cursor info
	let {$cursor} = state.selection as TextSelection
	if (!$cursor) return false;
	//console.log("Depth " + $cursor.depth + " is node " + $cursor.parent.type.name+" pos="+$cursor.pos);

	const parentType = $cursor.parent.type;
	const paragraphType = state.schema.nodes.paragraph;
	const blockquoteType = state.schema.nodes.blockquote;

	if (parentType === paragraphType) {
		const isEmpty = $cursor.parent.content.size === 0;
		if (isEmpty) {
			// We should lift DT/DD to paragraph
			const grandparent = $cursor.node($cursor.depth - 1);
			if (!grandparent || grandparent.type !== blockquoteType) return false;	// not in blockqoute

			const pos = $cursor.pos; // Cursor position
			const index = $cursor.index($cursor.depth - 1 /*this level points to BQ */ ); // Index of the P in the BQ
			const qStart = $cursor.start($cursor.depth - 1); // Start of the BQ
			const qEnd = $cursor.end($cursor.depth - 1); // End of the BQ

			// Determine if there are siblings before or after
			const hasBefore = index > 0;
			const hasAfter = qEnd > pos + 1;

			const tr = state.tr;
			tr.delete(pos - 1, pos + 1);	// Remove the empty P
			if (hasAfter && hasBefore) {
				tr.split(pos - 1); // Split the <blockqoute> into two
			}
			tr.insert(pos, paragraphType.createAndFill());
			tr.setSelection(TextSelection.create(tr.doc, pos+1, pos+1));

			if (dispatch) dispatch(tr.scrollIntoView());
			return true;
		}
	}
	return false;
};
